/**
 * 常见证据检索服务
 * @description 处理常见证据检索的业务逻辑
 */
export const CommonEvidenceSearchService = Symbol.for('CommonEvidenceSearchService');

/**
 * 常见证据检索结果
 */
export interface CommonEvidenceSearchResult {
    /**
     * 匹配到公知证据的技术特征数量
     */
    matchedFeaturesCount: number;
}

/**
 * 常见证据检索服务接口
 */
export interface CommonEvidenceSearchService {
    /**
     * 执行常见证据检索
     * @description 根据选中的技术特征和专利执行常见证据检索，并将结果存储到模型中
     * @returns Promise<CommonEvidenceSearchResult> 返回匹配结果统计
     */
    searchCommonEvidence(): Promise<CommonEvidenceSearchResult>;

    /**
     * 预热特征拆解&语义检索
     * @description 调用搜索特征提取接口，预热后端服务，加速后续的公知证据检索
     * @returns Promise<void>
     */
    preheatFeatureExtraction(): Promise<void>;

    /**
     * 加载公知证据最终结果
     * @description 从数据库中加载已完成的公知证据检索结果，并存储到模型中
     * @returns Promise<void>
     */
    loadFinalCommonEvidenceResult(): Promise<void>;
}
